import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { CustomOfferPayoutsDialogComponent } from './custom-offer-payouts-dialog/custom-offer-payouts-dialog.component';
import { Charter } from 'anchor-shared/lib/model/entity/charter';
import { VesselRate } from 'anchor-shared/lib/model/entity/vessel-rate';

@Injectable({
  providedIn: 'root',
})
export class CustomOfferPayoutsDialogService {
  constructor(private dialog: MatDialog) {}

  public open(
    charter: Charter,
    offerTitle: string,
    offerPrice: number,
    offerDuration: number,
    offerVesselId: number,
    customOriginalRates,
    customAddOns,
    viewOnly: boolean = false,
  ): Observable<any> {
    let dialogRef: MatDialogRef<any>;
    const mobile = window && window.screen && window.screen.width < 960;
    const config: any = {
      data: {
        charter,
        offerTitle,
        offerPrice,
        offerDuration,
        offerVesselId,
        customOriginalRates,
        customAddOns,
        viewOnly,
      },
      width: '600px',
      minWidth: '330px',
      height: '650px',
      autoFocus: false,
    };

    dialogRef = this.dialog.open(CustomOfferPayoutsDialogComponent, config);

    return dialogRef.afterClosed();
  }
}
